module.exports = __webpack_public_path__ + "static/media/chevron-square-left.65520e66.svg";